import SurveyStart from '@blocks/SurveyStart';
import Question from '@components/Question';
import { PillarType } from '@data/types';
import useQuestionnaireStore from '@store/questionnaire';
import classNames from 'classnames';
import React from 'react';
import { hash } from 'utilities/helper';

import Results from './Results';

interface Props extends PillarType {
  as?: keyof JSX.IntrinsicElements;
}

const Pillar: React.FC<Props> = ({
  questions,
  pillarIndex = 0,
  className = '',
  htmlContent,
  resultsHtmlContent,
}) => {
  const { displayResultsStore, pillarIndexStore } = useQuestionnaireStore();

  // Exit if pillar is set to be visible
  if (pillarIndexStore !== pillarIndex) return null;

  // First pillar - start survey
  if (pillarIndex === 0) {
    return <SurveyStart questions={questions} htmlContent={htmlContent} />;
  }

  // Other pillars
  return (
    <ul
      className={classNames(
        'md:absolute md:inset-0 md:duration-500 md:transition-opacity',
        className
      )}
    >
      {questions.map((item, index) => (
        <Question
          {...item}
          key={hash(item)}
          length={questions.length}
          index={index}
          pillarIndex={pillarIndex}
          htmlContent={htmlContent}
        />
      ))}
      {displayResultsStore && (
        <Results
          htmlContent={resultsHtmlContent}
          displayResults={displayResultsStore}
          pillarIndex={pillarIndex}
        />
      )}
    </ul>
  );
};

export default Pillar;
